import React, { useEffect, useState } from "react";
import { Col } from "reactstrap";
import { genericGet } from "services/services.general";
import styled from "styled-components";
import RepresentativesContainer from "./RepresentativesContainer";
import { getRepresentativeRegions } from "./utility";

const HeaderTextSection = styled.div`
  text-align: center;
  margin-bottom: 3rem;
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  margin-top: 50px;
  margin-bottom: 44px;
  flex-direction: column;
`;

const ParentContainer = styled(Col)`
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

const Container = styled.div`
  display: grid;
  justify-content: center;
  grid-template-columns: 400px 400px 400px;
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 250px 250px;
  }

  @media (max-width: 575px) {
    grid-template-columns: 200px;
  }

  @media (min-width: 768.98px) and (max-width: 1200px) {
    grid-template-columns: 300px 300px;
  }
`;

const Main = () => {
  const [filteredData, setFilteredData] = useState([]);

  const fetchData = () => {
    genericGet({
      url: "/region",
      callback: (data) => {
        const regions = data?.length !== 0 ? data : [];

        const result = getRepresentativeRegions(regions);
        setFilteredData(result);
      },
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <HeaderSection>
        <HeaderTextSection>
          <h1>{"House Members"}</h1>
        </HeaderTextSection>
      </HeaderSection>

      <Container>
        {filteredData?.length !== 0 &&
          filteredData?.map((datum) => {
            return (
              <Col
                key={datum?.id}
                xs="auto"
              >
                {datum?.map((d) => {
                  return (
                    <ParentContainer key={d?.id}>
                      <RepresentativesContainer
                        key={d?.id}
                        label={d?.label}
                        link={d?.link}
                      />
                    </ParentContainer>
                  );
                })}
              </Col>
            );
          })}
      </Container>
    </>
  );
};

export default Main;
